import type { ComponentProps } from "react";
import LogoSvg from "~/assets/svg/logo.svg?react";
import styles from "./OnboardingFlow.module.css";
import { OnboardingFlow } from "./OnboardingFlow";

type OnboardingPageProps = ComponentProps<typeof OnboardingFlow>;

// The onboarding as a page of its own: Smartli logo top-left on light grey,
// as the checkout page is.
export const OnboardingPage = (props: OnboardingPageProps) => (
  <div className={styles.page}>
    <LogoSvg className={styles.pageLogo} aria-label="Smartli" />
    <OnboardingFlow {...props} />
  </div>
);
